/* eslint-disable no-unsafe-optional-chaining */
import axios, { AxiosInstance } from 'axios';

import { getAccessToken, setAccessToken } from '@libraries/auth';

import type { SteadioApiError } from '@steadioTypes/common';

const instance: AxiosInstance = axios.create();

const loadAccessToken = async () => {
  const { data } = await axios.post('/api/v1/auth/user/token/refresh');
  const { result } = data.body;
  const { accessToken } = result;

  return accessToken;
};

// FIXME: 토큰 관련이슈로 be에서 accessToken 정보 cookie로 확인하도록 임시 적용됨
// instance.interceptors.request.use(async (config) => {
//   let accessToken;

//   // SSR 처리
//   if (typeof window === 'undefined') {
//     accessToken = await loadAccessToken();
//   } else {
//     accessToken = getAccessToken();
//   }

//   config.headers!['Authorization'] = `Bearer ${accessToken}`;
//   return config;
// });

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status || (0 as number);
    const errorCode = error?.response?.data?.body?.errorCode || ('' as string);
    if (noNeedToRetry(status, errorCode)) {
      throw createApiErrorObject(error);
    }

    try {
      const accessToken = await loadAccessToken();

      setAccessToken(accessToken);
      return instance.request(error.config);
    } catch (error: any) {
      throw createApiErrorObject(error);
    }
  },
);

const noNeedToRetry = (status: number, errorCode: string): boolean =>
  status !== 401 || errorCode !== '0102';

const createApiErrorObject = (error: any): SteadioApiError => {
  const { status } = error?.response;
  const { body = {} } = error?.response?.data;
  const { errorCode = '', errorMessage = '' } = body;

  return { status, errorCode, errorMessage };
};

export { instance as authAxios, axios as pureAxios };
